import { Dialog } from '@ordr-as/umami-react/dialog';
import useIntl from '../../../../../hooks/useIntl';

interface CashConfirmationDialogProps {
  onContinue: () => void;
  onClose: () => void;
}

const CashConfirmationDialog = (props: CashConfirmationDialogProps) => {
  const { onContinue, onClose } = props;
  const intl = useIntl();

  return (
    <Dialog
      className="w-full mx-4 tablet:w-1/2 tablet:mx-0"
      onClose={onClose}
      title={intl.formatMessage({ id: 'paymentButton.cashConfirmationDialog.title' })}
      onAction={onContinue}
      actionLabel={intl.formatMessage({ id: 'paymentButton.cashConfirmationDialog.actionLabel' })}
      onSecondaryAction={onClose}
      secondaryActionLabel={intl.formatMessage({ id: 'paymentButton.cashConfirmationDialog.secondaryActionLabel' })}
    >
      {intl.formatMessage({ id: 'paymentButton.cashConfirmationDialog.message' })}
    </Dialog>
  );
};

export default CashConfirmationDialog;
